import { CreateMenu_Body, DeleteMenu_Params, IMenu, UpdateMenu_Body, UpdateMenu_Params, UpdateMenu_Response, createMenu, deleteMenu, getMenusList, updateMenu } from '@/services/menu-service';
import { AsyncThunkConfig } from '@/store';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MenuBoardDraft } from '../../menu-board/functions/menu-board-draft';

const initialState: initialStateType = {
  loading: false,
  menuList: [],
};

const dataSlice = createSlice({
  name: 'menuList/data',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMenusListThunk.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getMenusListThunk.fulfilled, (state, action) => {
      state.menuList = action.payload || [];
      state.loading = false;
    });
    builder.addCase(createMenuThunk.fulfilled, (state, action) => {
      if (action.payload !== null) state.menuList = [...state.menuList, action.payload];
    });
    builder.addCase(updateMenuThunk.fulfilled, (state, action) => {
      state.menuList = state.menuList.map((item) => (item._id === action.payload?._id ? action.payload : item));
    });
    builder.addCase(deleteMenuThunk.fulfilled, (state, action) => {
      state.menuList = state.menuList.filter((item) => item._id !== action.payload?._id);
      if (action.payload) MenuBoardDraft.Delete(action.payload._id);
    });
  },
});

export default dataSlice.reducer;
interface initialStateType {
  loading: boolean;
  menuList: Array<Omit<IMenu, 'categories'>>;
}

// ASYNC THUNKS
export const getMenusListThunk = createAsyncThunk('menuList/getMenusListThunk', async () => {
  const response = await getMenusList();
  return response.data.data;
});

export const createMenuThunk = createAsyncThunk('menuList/createMenuThunk', async (body: CreateMenu_Body) => {
  const response = await createMenu(body);
  return response.data.data;
});

export const updateMenuThunk = createAsyncThunk<UpdateMenu_Response['data'], { params: UpdateMenu_Params; body: UpdateMenu_Body }, AsyncThunkConfig>('menuList/updateMenu', async ({ params, body }, { dispatch, getState }) => {
  const response = await updateMenu(params, body);
  return response.data.data;
});

export const deleteMenuThunk = createAsyncThunk('menuList/deleteMenu', async (params: DeleteMenu_Params) => {
  const response = await deleteMenu(params);
  return response.data.data;
});
